import React from 'react';
import './Comparison.scss';

const Comparison: React.FC = () => {
  const features = [
    { name: 'Battery Life', shadow: '24 months', airtag: '12 months', tile: '3 years (non-replaceable)' },
    { name: 'Real-Time Tracking', shadow: true, airtag: false, tile: false },
    { name: 'Stealth Design', shadow: true, airtag: false, tile: false },
    { name: 'Weatherproof (IP67)', shadow: true, airtag: true, tile: false },
    { name: 'Global Coverage', shadow: true, airtag: 'Limited', tile: 'Limited' },
    { name: 'Movement Alerts', shadow: true, airtag: false, tile: true },
    { name: 'Monthly Cost', shadow: '$15.95', airtag: 'Free', tile: 'Free' },
    { name: 'Theft Recovery', shadow: 'Active GPS', airtag: 'Crowd-sourced', tile: 'Crowd-sourced' }
  ];

  const renderCell = (value: any) => {
    if (typeof value === 'boolean') {
      return value ? <span className="check">✓</span> : <span className="cross">✗</span>;
    }
    return value;
  };

  return (
    <section className="comparison">
      <div className="container">
        <h2>Why Choose Shadow Tracker?</h2>
        <p className="subtitle">See how we compare to other tracking solutions</p>
        
        <div className="comparison-table">
          <div className="table-header">
            <div className="header-cell feature-col">Feature</div>
            <div className="header-cell shadow-col">
              <div className="product-name">Shadow Tracker</div>
              <div className="product-badge">Recommended</div>
            </div>
            <div className="header-cell">Apple AirTag</div>
            <div className="header-cell">Tile Pro</div>
          </div>
          
          {features.map((feature, index) => (
            <div key={index} className="table-row">
              <div className="table-cell feature-col">{feature.name}</div>
              <div className="table-cell shadow-col">{renderCell(feature.shadow)}</div>
              <div className="table-cell">{renderCell(feature.airtag)}</div>
              <div className="table-cell">{renderCell(feature.tile)}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Comparison;
